// Query Parameter Constants organized by feature/scope
export const QUERY_PARAMS = {
  // Common parameters shared across features
  COMMON: {
    PARENT_ORIGIN: "parentOrigin",
    ACTIVE_VEHICLE: "activeVehicle",
    SELECTED_MARKER: "selectedMarker",
    MARKERS_AFTER: "markersAfter",
    SEARCH_TERM: "searchTerm",
  },
  // Dispatch-specific parameters
  DISPATCH: {
    VEHICLES: "vehicles",
    RESPOND: "respond",
    MISSION_TO_LAUNCH: "missionToLaunch",
    OPERATION_UUID: "operationUuid",
    TELEOP_META_MAP: "teleopMetaMap",
    /** Base64 encoded map of vehicleId -> custom URL for RFD panels */
    RFD_URL_MAP: "rfdUrlMap",
    /** Deeplink: opens the marker details panel for the given marker UUID */
    MARKER_UUID: "marker_uuid",
  },
  // Teleop-specific parameters
  TELEOP: {
    FROM: "from",
    DFR: "dfr",
    VIEW_ONLY: "viewOnly",
    SELECTED_SKILL: "selectedSkill",
    MISSION_TO_EDIT: "editMissionId",
    MULTIDRONE_AUTOLAUNCH: "multidroneAutoLaunch",
    RTIC: "rtic",
    SUPPRESS_POST_FLIGHT_SURVEY: "suppressPostFlightSurvey",
  },
  // TODO: ReadyLink
} as const;

// Type-safe access to all query parameters
export type QueryParamKey =
  | (typeof QUERY_PARAMS.COMMON)[keyof typeof QUERY_PARAMS.COMMON]
  | (typeof QUERY_PARAMS.DISPATCH)[keyof typeof QUERY_PARAMS.DISPATCH]
  | (typeof QUERY_PARAMS.TELEOP)[keyof typeof QUERY_PARAMS.TELEOP];
